<span class="line-clamp-2 text-xl sm:text-2xl text-default-light font-semibold tracking-tighter">{{title()}}</span>
